import type { FC } from 'react';
import AcuteHelpCard from '../Card/AcuteHelpCard';
import FAQSection from '../Faq/FAQSection';
import { useSelectedCategories } from '@/redux/selectors/categorySelector';

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();
  const activeCategories = useSelectedCategories();

  const showFooter = activeCategories.length === 0 || activeCategories.includes('all');

  return (
    showFooter && (
      <footer>
        <AcuteHelpCard />
        <FAQSection />
        <div className="p-4">
          <p className="text-center text-sm text-gray-500">
            &copy; {currentYear} Bloom. All rights reserved.
          </p>
        </div>
      </footer>
    )
  );
};

export default Footer;
